export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ja",
    "resource": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["集荷依頼を承りました。ありがとうございます。\n 2営業日以内に、集荷日のご連絡が別途ご登録のメールアドレスまで送信されます。"])}
    }
  })
}
